export const supplierRules = {
  supplierName: [(v) => !!v || "Supplier Name is required"],
  phoneNumber: [(v) => !!v || "Phone Number is required"],
  emailAddress: [
    (v) => !!v || "Email Address is required",
    (v) =>
      !v ||
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "E-mail must be valid",
  ],
  licenseNumber: [(v) => !!v || "License Number is required"],
  country: [(v) => !!v || "Country is required"],
  state: [(v) => !!v || "State is required"],
  city: [(v) => !!v || "City is required"],
  zipCode: [(v) => !!v || "Zip Code is required"],
};
